<template>
  <div>
    <v-container>
      <div>
        <v-btn
          :loading="loading"
          color="grey"
          :disabled="delayImport"
          outline
          @click="onClickUploadButton"
        >
          <em class="fas fa-file-import" />
          &nbsp;
          {{ $t('Import Employee') }}
        </v-btn>
        <input
          type="file"
          :key="`file__${keyupload}`"
          class="form-control-file pt-2"
          name="csvUploadCentralHr"
          :id="'csvUploadCentralHr'"
          data-vv-as="File"
          v-validate="'mimes:text/xlsx'"
          accept=".xlsx"
          @input="onFileChange($event)"
          style="
            overflow: hidden;
            position: fixed;
            width: 1px;
            height: 1px;
            z-index: -1;
            opacity: 0;
          "
        />
      </div>
      <div>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="data"
          class="elevation-1"
          v-bind:pagination.sync="pagination"
          hide-actions
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item['Employee ID'] ? props.item['Employee ID'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Firstname'] ? props.item['Firstname'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Last Name'] ? props.item['Last Name'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Identification ID'] ? props.item['Identification ID'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Company'] ? props.item['Company'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Branch'] ? props.item['Branch'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Hire Date'] ? props.item['Hire Date'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Corporate Title'] ? props.item['Corporate Title'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Gender'] ? props.item['Gender'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Work Location'] ? props.item['Work Location'] : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item['Function'] ? props.item['Function'] : '-' }}
              </td>
            </tr>
          </template>

          <div class="text-xs-center" slot="no-data">{{ $t('No Employee') }}</div>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import api from '@/api'
import moment from 'moment'

export default {
  components: {},
  data() {
    return {
      keyupload: 0,
      delayImport: false,
      loading: false,
      data: [],
      pagination: { rowsPerPage: -1 },
      headers: [
        { text: 'Employee ID', value: 'Employee ID' },
        { text: 'Firstname', value: 'Firstname' },
        { text: 'Last Name', value: 'Last Name' },
        { text: 'Identification ID', value: 'Identification ID' },
        { text: 'Company', value: 'Company' },
        { text: 'Branch', value: 'Branch' },
        { text: 'Hire Date', value: 'Hire Date' },
        { text: 'Corporate Title', value: 'Corporate Title' },
        { text: 'Gender', value: 'Gender' },
        { text: 'Work Location', value: 'Work Location' },
        { text: 'Function', value: 'Function' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    }
  },
  mounted() {
    this.getEmployee()
  },
  methods: {
    getEmployee() {
      var vm = this
      vm.loading = true
      var data = {
        pageid: vm.selectedBot.pageid
      }
      api.getcentralhremployee(data, (err, response) => {
        if (response && response.responsecode == 200) {
          vm.data = response.data
        }
        vm.loading = false
      })
    },
    onClickUploadButton() {
      document.getElementById('csvUploadCentralHr').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array', cellDates: true })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          var jsonresult = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
          jsonresult = jsonresult.map((obj) => {
            var objdata = obj
            for (const [key, value] of Object.entries(objdata)) {
              if (typeof value.getMonth === 'function') {
                objdata[key] = moment(value).format('DD/MM/YYYY')
              }
            }
            return objdata

            // if(typeof el[key].getMonth === 'function') {

            // } else {

            // }
          })
          result.push(vm.trimObj(jsonresult))
        }

        vm.uploadExcel(result)
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      // console.log(obj)
      var result = Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )

      return result
    },
    uploadExcel(file) {
      var vm = this

      if (file && file.length) {
        var filteredFile = file[0].filter((el) => {
          return el['Employee ID'] && el['Firstname'] && el['Last Name'] && el['Identification ID']
        })
        if (filteredFile && filteredFile.length) {
          var data = {
            pageid: vm.selectedBot.pageid,
            files: [filteredFile]
          }
          api.postcentralhremployee(data, (error, response) => {
            if (error) {
              console.error(error)
            } else {
              if (response.responsecode == 200) {
                vm.$swal.fire({
                  text: 'สำเร็จ'
                })
                vm.keyupload++
                vm.getEmployee()
              }
            }
          })
        } else {
          this.$swal.fire({
            text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
          })
          this.loading = false
        }
      } else {
        console.log('wwwww')
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/centralhr/uploadUser.vue